export const DYNAMIC_PHONE_VALIDATION_CONFIG = {
  prefix: 'prefix_phone',
  number: 'phone_number',
};
